// LetterSpaceIcon.tsx

import React from "react";

export const LetterSpaceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" {...props}>
      <line x1="0.168293" y1="0.449219" x2="0.168293" y2="15.5524" stroke="currentColor" strokeWidth="0.336587" />

      <line x1="16.1683" y1="0.449219" x2="16.1683" y2="15.5524" stroke="currentColor" strokeWidth="0.336587" />

      <path
        d="M11.5517 11.3265H10.4971L9.84208 9.68352H6.1564L5.50141 11.3265H4.44678L7.42196 3.92188H8.56541L11.5517 11.3265ZM9.56454 8.86202L7.99924 4.8766L6.42283 8.86202H9.56454Z"
        fill="currentColor"
      />
    </svg>
  );
};
